import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_FOLLOWING').plugin(axiosPlugin);

let addUserFollowingAction = redux.fetchActionCreate();

let removeUserFollowingAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const addUserFollowing = (userId, profileId, query = {}) => addUserFollowingAction(`/users/${userId}/following-profile/${profileId}?${queryString.stringify(query)}`);
export const removeUserFollowing = (userId, profileId, query = {}) => removeUserFollowingAction(`/users/${userId}/following-profile/${profileId}?${queryString.stringify(query)}`);
export const resetUserFollowing = () => redux.actions.reset();

export const userFollowing = redux.reducer();